// @flow

import type {ApiError, ApiSuccess} from '@travel-frontend/state-handling-sdk';
import type {AsyncAction} from 'redux/types';
import type {Customer, Errors} from 'redux/v1/customer/data/models';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const FETCH_CUSTOMER = 'v1/customer/data/FETCH_CUSTOMER';

export type FetchCustomerSuccess = ApiSuccess<Customer, *>;

export type FetchCustomerError = ApiError<Errors, *>;

export function fetchCustomer(journeyId: number, token: string): AsyncAction {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };

  return {
    types: ASYNC_TYPES(FETCH_CUSTOMER),
    callAPI: () =>
      axios
        .get(`${cfg.bookingServiceUrl}/customer/${journeyId}`, config)
        .then((res) => res.data)
        .catch((error) => { throw error.response.data; }),
  };
}
